// Auto-complete an Artist name

// console.log('dropdown JS file is going to be read.');

import {autocompleteArtist} from './autocomplete_artist.js';

var model = 'engage';
$(autocompleteArtist(model));

